import React, { useEffect, useState } from "react";

export function useRedirectToCertification(subpath = "") {
  useEffect(() => {
    window.location.replace(`https://byblack.us/certification/${subpath}`);
  }, []);
}
